/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PatientListAliases {
  AUTOCOMPLETE_DEPARTMENTS = 'autocomplete-departments',
  AUTOCOMPLETE_ENCOUNTER_TYPE = 'autocomplete-encounter-type',
  CHECKBOX_MY_PATIENTS = 'checkbox-my-patients',
  CHECKBOX_ONLY_DISCHARGED_PATIENTS = 'checkbox-only-discharged-patients',
  CHECKBOX_RECENT_PATIENTS = 'checkbox-recent-patients',
  CONTEXTUAL_BAR = 'contextual-bar',
  DATEFIELD_FROM_DATE = 'datefield-from-date',
  DATEFIELD_TO_DATE = 'datefield-to-date',
  FETCH_DEPARTMENTS = 'fetch-departments',
  FETCH_ENCOUNTER_TYPE = 'fetch-encounter-type',
  FIELD_DEPARTMENTS = 'field-departments',
  FIELD_ENCOUNTER_TYPE = 'field-encounter-type',
  FIELD_FROM_DATE = 'field-from-date',
  FIELD_TO_DATE = 'field-to-date',
  FILTER_FIELD_DISCHARGED_PERIOD = 'filter-field-discharged-period',
  FILTER_FIELD_ENCOUNTER = 'filter-field-encounter',
  FILTER_FIELD_MRN = 'filter-field-mrn',
  FILTER_FIELD_MY_PATIENTS = 'filter-field-my-patients',
  FILTER_FIELD_NAME = 'filter-field-name',
  FILTER_FIELD_ONLY_DISCHARGED_PATIENTS = 'filter-field-only-discharged-patients',
  FILTER_FIELD_RECENT_PATIENTS = 'filter-field-recent-patients',
  FILTER_PATIENTS = 'filter-patients',
  FILTERED_LIST = 'filtered-list',
  INPUT_ENCOUNTER = 'input-encounter',
  INPUT_MRN = 'input-mrn',
  INPUT_NAME = 'input-name',
  MAPPER_DEPARTMENTS = 'mapper-departments',
  MAPPER_ENCOUNTER_TYPE = 'mapper-encounter-type',
  PATIENT_FETCH = 'patient-fetch',
  PATIENT_FETCH_AVATAR = 'patient-fetch-avatar',
  PATIENT_FETCH_CARD = 'patient-fetch-card',
  PATIENT_FETCH_DECK = 'patient-fetch-deck',
  PATIENT_FETCH_MAPPER = 'patient-fetch-mapper',
  PATIENT_FETCH_PANEL = 'patient-fetch-panel',
  PATIENT_LIST_LAYOUT = 'patient-list-layout',
  TEXT_DEPARTMENTS = 'text-departments',
  TEXT_DISCHARGED_PERIODO = 'text-discharged-periodo',
  TEXT_ENCOUNTER_TYPE = 'text-encounter-type',
}
export { PatientListAliases };
